<img class="icon" src="../../../../../assets/img/icons/ico.16.alert.svg" alt="Alert">
<div class="textbox">
  <p class="text" [innerHTML]="row?.status "></p>
</div>

